import { KonfirmOrderState, KonfirmOrderResponseProps } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { confirmOrder } from './confirmOrder.services';

export const initialState: KonfirmOrderState = {
    data: {} as KonfirmOrderResponseProps,
    status: "loading",
    error: {}
}

export const ConfirmOrderSlice = createSlice({
    name: 'confirmOrder',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(confirmOrder.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(confirmOrder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(confirmOrder.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const ConfirmOrderReducer = ConfirmOrderSlice.reducer